export const LanguageCode = {
  ENGLISH: 'en',
  ARABIC: 'ar',
};

export const LanguageId = {
  [LanguageCode.ENGLISH]: 1,
  [LanguageCode.ARABIC]: 2,
};

//Organization names languages. These are defined in the Backend side.
const OrganizationLanguage = {
  [LanguageCode.ENGLISH]: 'english',
  [LanguageCode.ARABIC]: 'arabic',
};

export const getOrganizationLanguage = languageCode => {
  return OrganizationLanguage[languageCode];
};
